// extracted by mini-css-extract-plugin
module.exports = {"marquee":"styles_marquee__yksMl","marquee__inner":"styles_marquee__inner__Lm73K"};